import React, { useEffect } from 'react';

function EventLogCrud() {
  useEffect(() => {
    new App.Routers.EventLog().list();
  }, []);

  return (
    <div id="EventLogGrid" />
  );
}

export default EventLogCrud;
